import { Box, Typography } from "@mui/material";
import { AgMuiSelect2 } from "./Controlled";

export function DetailsSelect({ label, control, name, options, values, onChange }) {
    return <Box sx={{ width: "100%" }}>
        <Typography sx={{ fontFamily: "Figtree", fontSize: "12px", fontWeight: "bold", color: "balck" }}>{label}</Typography>
        <AgMuiSelect2  rules={{required : "Required"}} values={values} onChangeHandler={(value) => {
            console.log("the value is ",value)
            if(onChange){
                onChange(value);
            }
        }} fontSize="12px" width="100%" fullwidth options={options} control={control} name={name} />
    </Box>
}

export function DetailsSelect2({ label, control, name, options, values, onChange,disabled }) {
    return <div className="flex flex-row items-center gap-2.5">
        <p className="text-grey font-sm text-nowrap">{label}</p>
        <AgMuiSelect2 disabled={disabled} rules={{required : "Required"}} values={values} onChangeHandler={(value) => {
            console.log("the value is ",value)
            if(onChange){
                onChange(value);
            }
        }} fontSize="12px" width="100%" options={options} control={control} name={name} style={{minWidth:"160px",height:"30px"}} />
    </div>
}